<template>
    <v-layout justify-center class="pa-4">
        <v-responsive width="100%" height="100%">
            <list-heading title="캐시 내역" v-model="showsSearch" showsFilterButton />

            <list-search-default
                v-bind="{
                    showsSearch,
                    loading,
                    searchKeys,
                }"
                v-on="{ search }"
            />

            <v-row class="ma-n2 mt-n1">
                <v-col class="pa-2" cols="auto" md="auto">
                    <list-summary v-bind="{ summary }" />
                </v-col>
                <v-col class="pa-2" cols="12" md="auto">
                    <cash-list-type />
                </v-col>
                <v-spacer />
                <v-col class="pa-2" cols="auto" md="auto">
                    <list-excel v-slot="{ attrs, on }" v-on="{ excel }">
                        <v-card outlined style="overflow: hidden;">
                            <v-btn height="40" color="white" elevation="0" class="text-caption green--text" style="margin:-1px" v-bind="{ ...attrs, loading }" v-on="on">
                                <v-icon> mdi-microsoft-excel </v-icon>
                                <span> 엑셀다운로드 </span>
                            </v-btn>
                        </v-card>
                    </list-excel>
                </v-col>
                <v-col class="pa-2" cols="12">
                    <v-data-table v-bind="{ loading, headers, items }" disable-sort disable-pagination hide-default-footer class="v-sheet--outlined" :items-per-page="-1">
                        <template v-for="(header, index) in headers.filter((header) => header.hasOwnProperty('formatter'))" #[`item.${header.value}`]="{ value, item }"> <span :key="index" :title="header.withTitle ? header.formatter.bind(item)(value, item) : undefined" v-html="header.formatter.bind(item)(value, item)" /> </template>

                        <template #[`item.tno`]="{ item }">
                            <cash-gift-view v-if="item.type == '선물' && item.gift" :gift="item.gift">
                                <template #activator="{ attrs, on }">
                                    <v-btn x-small text tile class="pa-0 caption" v-bind="attrs" v-on="on">{{ item.tno || "-" }}</v-btn>
                                </template>
                            </cash-gift-view>
                            <span v-else>{{ item.tno || "-" }}</span>
                        </template>

                        <template #footer>
                            <v-divider />
                            <v-pagination :value="page" :length="pageCount" :total-visible="11" color="primary" class="my-2" @input="(page) => $router.push({ query: { ...$route.query, page } })" />
                        </template>
                    </v-data-table>
                </v-col>
            </v-row>
        </v-responsive>
    </v-layout>
</template>

<script>
import api from "@/api";
import { initDataTableHeaders } from "@/assets/lib";

import ListExcel from "@/components/console/dumb/list/list-excel.vue";
import ListHeading from "@/components/console/dumb/list/list-heading.vue";
import ListSearchDefault from "@/components/console/dumb/list/list-search-default.vue";
import ListSummary from "@/components/console/dumb/list/list-summary.vue";
import CashGiftView from "@/components/console/user/cashes/cash-gift-view.vue";
import CashListType from "@/components/console/user/cashes/cash-list-type.vue";

const headers = initDataTableHeaders([
    {
        text: "no",
        value: "index",
        width: +80,
        align: "end",
        formatterType: "number",
    },
    {
        text: "승인일시",
        value: "createdAt",
        width: 110,
        formatterType: "datetime",
    },
    {
        text: "결제타입",
        value: "type",
        width: 160,
    },
    {
        text: "주문번호",
        value: "orderNo",
        width: 160,
    },
    {
        text: "승인번호",
        value: "tno",
        width: 160,
    },
    {
        text: "캐시내역",
        value: "remark",
    },
    {
        text: "금액",
        value: "amount",
        align: "end",
        formatterType: "number",
        formatterSuffix: "원",
        width: 110,
    },
    {
        text: "잔액",
        value: "result",
        align: "end",
        formatterType: "number",
        formatterSuffix: "원",
        width: 110,
    },
    {
        text: "ID",
        value: "member.username",
        width: 160,
    },
    {
        text: "이름",
        value: "member.name",
        formatter: (value) => value || "탈퇴회원",
        width: 160,
    },
]);

// 선물 상세는 목록에서 다이얼로그로만 보여주므로, 엑셀에만 별도 컬럼으로 덧붙인다.
const excelHeaders = initDataTableHeaders([
    {
        text: "보낸사람",
        value: "gift.sender",
        formatter: (value) => (value?.name ? `${value.name}(${value.username || "-"})` : "-"),
    },
    {
        text: "받은사람",
        value: "gift.receiver",
        formatter: (value) => (value?.name ? `${value.name}(${value.username || "-"})` : "-"),
    },
    {
        text: "받은일자",
        value: "gift.takedAt",
        formatterType: "datetime",
    },
]);

const searchKeys = [
    { text: "주문번호", value: "orderNo" },
    { text: "승인번호", value: "tno" },
    { text: "이름", value: "member.name" },
    { text: "아이디", value: "member.username" },
    { text: "연락처", value: "member.phone" },
];

export default {
    components: {
        ListExcel,
        ListHeading,
        ListSearchDefault,
        ListSummary,
        CashGiftView,
        CashListType,
    },
    data: () => ({
        cashes: [],

        limit: 20,
        summary: { totalCount: 0 },

        headers,
        searchKeys,

        loading: false,
        showsSearch: true,
    }),
    computed: {
        items() {
            return this.cashes.map((item, index) => ({
                ...item,
                index: this.summary.totalCount - index - this.skip,
            }));
        },
        page() {
            return +(this.$route.query.page || "1");
        },
        skip() {
            return (this.page - 1) * this.limit;
        },
        pageCount() {
            return Math.ceil(this.summary.totalCount / this.limit) || 1;
        },
        params() {
            let { ...query } = this.$route.query;

            delete query.page;

            return { ...query };
        },
    },
    methods: {
        async init() {
            this.cashes = [];
            this.summary = { totalCount: 0 };
            this.loading = false;

            await this.search();
        },

        async search() {
            if (this.loading) return;
            else this.loading = true;

            try {
                let { skip, limit, params } = this;
                let { summary, cashes } = await api.console.cashes.gets({
                    headers: { skip, limit },
                    params,
                });

                this.summary = summary;
                this.cashes = cashes;
            } finally {
                this.loading = false;
            }
        },

        async excel({ skip = 0, limit = 0 } = {}) {
            if (this.loading) return;
            else this.loading = true;

            try {
                let { params } = this;
                let { cashes } = await api.console.cashes.gets({
                    headers: { skip, limit },
                    params,
                });

                this.$excel(cashes, [...headers, ...excelHeaders], "캐시내역");
            } finally {
                this.loading = false;
            }
        },
    },
    watch: {
        params() {
            this.search();
        },
    },
    mounted() {
        this.init();
    },
};
</script>

<style lang="scss" scoped>
::v-deep {
    .line-height-1-3 {
        line-height: 1.3;
    }
    .line-height-1-5 {
        line-height: 1.5;
    }
    .white-space-pre-line {
        white-space: pre-line;
    }
    .v-pagination button {
        box-shadow: none !important;
        border: thin solid rgba(0, 0, 0, 0.12);
    }

    th:first-of-type:not(:last-of-type),
    td:first-of-type:not(:last-of-type) {
        border-right: thin solid rgba(0, 0, 0, 0.12);
    }
}
</style>
